var React = require('react');

function IconSwap (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M728.9 950.6L502.1 639.8l146.4-1.8-2.9-448 168.8-4.1-.2 454.2 146.2 2.6-231.5 307.9zM291 72.9L64.2 383.8l146.4 1.8-2.9 448 168.8 4.1-.2-454.2 146.2-2.6L291 72.9z"}));
}

IconSwap.displayName = "IconSwap";

IconSwap.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconSwap;

IconSwap.default = IconSwap;
